import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {getIconColor} from './helpers';

import styles from './icon-only-button.module.css';

export type ButtonVariant = 'default' | 'purple' | 'orange' | 'danger';

type Props = {
    icon: React.ComponentType<any>;
    onClick: (e: React.SyntheticEvent<any>) => void;
    // Normal: 24px, Large: 32px
    size?: 'normal' | 'large';
    tooltipText?: string;
    isDisabled?: boolean;
    isActive?: boolean;
    hasBorder?: boolean;
    // Variants only affect the active state of the buttons
    variant?: ButtonVariant;
    getButtonRef?: any;
    id?: string;
    // Direction to tilt on hover with a slight lift
    hoverTilt?: 'left' | 'right';
};

export const IconOnlyButton = (props: Props) => {
    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => ReactTooltip.hide();
    }, []);

    const {
        icon: Icon,
        onClick,
        size = 'normal',
        tooltipText,
        isDisabled = false,
        isActive = false,
        hasBorder,
        variant = 'default',
        getButtonRef,
        hoverTilt,
    } = props;

    const buttonStyles = classnames(styles['icon-only-button'], {
        [styles['icon-only-button--size-24']]: size === 'normal',
        [styles['icon-only-button--size-32']]: size === 'large',
        [styles['icon-only-button--active']]: isActive,
        [styles['icon-only-button--disabled']]: isDisabled,
        [styles['icon-only-button--border']]: hasBorder,
        [styles['icon-only-button--purple']]: variant === 'purple',
        [styles['icon-only-button--orange']]: variant === 'orange',
        [styles['icon-only-button--danger']]: variant === 'danger',
        [styles['icon-only-button--hover-tilt-left']]: hoverTilt === 'left',
        [styles['icon-only-button--hover-tilt-right']]: hoverTilt === 'right',
    });

    const iconColor = getIconColor(isDisabled, isActive, variant);

    const handleClick = (e: React.SyntheticEvent<any>) => {
        if (isDisabled) {
            return;
        }
        onClick(e);
    };

    return (
        <button
            id={props.id}
            type='button'
            onClick={handleClick}
            ref={getButtonRef}
            data-tip={tooltipText}
            className={buttonStyles}
        >
            <Icon
                wrapWithDiv={false}
                size={20}
                alignCenter={true}
                color={iconColor}
                fill={iconColor}
            />
        </button>
    );
};
